export var ITemplateCategory;
(function (ITemplateCategory) {
    ITemplateCategory["Blank"] = "Blank";
    ITemplateCategory["Image"] = "Image";
    ITemplateCategory["Face"] = "Face";
    ITemplateCategory["World"] = "World";
    ITemplateCategory["Content360"] = "Content360";
})(ITemplateCategory || (ITemplateCategory = {}));
export var IDomIdSelectors;
(function (IDomIdSelectors) {
    IDomIdSelectors["zapparCanvas"] = "zapparCanvas";
    IDomIdSelectors["zapparApp"] = "zappar-app";
    IDomIdSelectors["screenRelativeCanvas"] = "screenRelativeCanvas";
    IDomIdSelectors["smSlide"] = "sm-slide";
    IDomIdSelectors["uploadDialog"] = "uploadDialog";
    IDomIdSelectors["root"] = "root";
    IDomIdSelectors["undo"] = "undo";
    IDomIdSelectors["redo"] = "redo";
    IDomIdSelectors["inspectorMenu"] = "inspectorMenu";
    IDomIdSelectors["setStartSceneDiv"] = "setStartSceneDiv";
})(IDomIdSelectors || (IDomIdSelectors = {}));
export var IDomClassSelector;
(function (IDomClassSelector) {
    IDomClassSelector["scenePopupMenu"] = "scene-popup-menu";
})(IDomClassSelector || (IDomClassSelector = {}));
export var IEntityShelves;
(function (IEntityShelves) {
    IEntityShelves["transforms"] = "transforms";
    IEntityShelves["previews"] = "previews";
    IEntityShelves["actions"] = "actions";
    IEntityShelves["appearances"] = "appearances";
    IEntityShelves["text"] = "text";
    IEntityShelves["transitions"] = "transitions";
    IEntityShelves["curve"] = "curve";
    IEntityShelves["chromaKey"] = "chromaKey";
    IEntityShelves["shadows"] = "shadows";
})(IEntityShelves || (IEntityShelves = {}));
export var IEntityDrawerTypes;
(function (IEntityDrawerTypes) {
    IEntityDrawerTypes["none"] = "none";
    IEntityDrawerTypes["button"] = "button";
    IEntityDrawerTypes["text"] = "text";
    IEntityDrawerTypes["image"] = "image";
    IEntityDrawerTypes["video"] = "video";
    IEntityDrawerTypes["model3d"] = "model3d";
    IEntityDrawerTypes["applets"] = "applets";
    IEntityDrawerTypes["entityList"] = "entityList";
})(IEntityDrawerTypes || (IEntityDrawerTypes = {}));
export var IEntityDrawerCategoryTypes;
(function (IEntityDrawerCategoryTypes) {
    IEntityDrawerCategoryTypes["private"] = "private";
    IEntityDrawerCategoryTypes["public"] = "public";
})(IEntityDrawerCategoryTypes || (IEntityDrawerCategoryTypes = {}));
export var ICanvasName;
(function (ICanvasName) {
    ICanvasName["selectedEntityPreview"] = "selectedEntityPreview";
    ICanvasName["webEmbedPreview"] = "webEmbedPreview";
    ICanvasName["modelUploadPreview"] = "modelUploadPreview";
    ICanvasName["screenRelativePreview"] = "screenRelativePreview";
    ICanvasName["targetImagePreview"] = "targetImagePreview";
    ICanvasName["videoPlayer"] = "videoPlayer";
    ICanvasName["camera360RotationPreview"] = "camera360RotationPreview";
})(ICanvasName || (ICanvasName = {}));
